import { getTvObject, tv } from '@costar-ui/cosmos';

var avatarTV = getTvObject({
  base: ['rounded'],
  //base = common styles
  variants: {
    size: {
      xs: ['w-12', 'aspect-1/1.15', 'min-w-12', 'max-h-14'],
      // 48px x 56
      sm: ['w-[7rem]', 'aspect-4/5', 'min-w-[7rem]', 'max-h-[8.75rem]'],
      // 112 x 140
      md: ['w-[8rem]', 'aspect-4/5', 'min-w-[8rem]', 'max-h-40'],
      // 128 x 160
      lg: ['w-[10rem]', 'aspect-4/5', 'min-w-[10rem]', 'max-h-[12.5rem]'] // 160 x 200
    }
  }
});
var base = {
  base: tv(avatarTV)
};
var avatarStyles = {
  base: base
};

export { avatarStyles, avatarTV };
//# sourceMappingURL=avatar.styles.esm.js.map
